import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Table } from '@feathr/components';
import { useLocalUrl, useStore } from '@feathr/extender/state';

import { donationFormsColumns } from './donationFormsColumns';

function DonationFormsTable(): JSX.Element {
  const { t } = useTranslation();
  const { DonationForms } = useStore();
  const localUrl = useLocalUrl();
  return <Table collection={DonationForms} columns={donationFormsColumns({ t, localUrl })} />;
}

export default observer(DonationFormsTable);
